import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap"

import { Link, withRouter } from "react-router-dom"

// Formik Validation
import { useFormik } from "formik"
import * as Yup from "yup"

import profile from "assets/images/login.svg"
import toast from "components/Toast/Toast"
import { withTranslation } from "react-i18next"
import { changePassViaEmail } from "services/auth/calls"
import { BgAnimado } from "./Components/BgAnimado/BgAnimado"
import { clientCapitalized } from "assets"

const client = process.env.REACT_APP_CLIENT || "Flash"

const ForgetPasswordPage = props => {
  document.title = `Esqueci minha senha | Sensetek ${clientCapitalized}`

  const { t } = props

  const [isLoading, setIsLoading] = useState(false)

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Por favor digite seu email."),
    }),
    onSubmit: async values => {
      try {
        setIsLoading(true)
        // const { status } = await changePassViaEmail(values.email)
        const payload = await changePassViaEmail(values.email)
        if (payload?.status === "success") {
          toast(
            "success",
            `Senha redefinida com sucesso. Um email foi enviado para ${values.email} com a nova senha.`,
            ""
          )
        } else {
          toast("warning", "Erro ao tentar redefinir a senha.", "Erro")
        }
      } catch (error) {
        console.log(error)
        if (error?.status === 404) {
          toast(
            "success",
            `Senha redefinida com sucesso. Um email foi enviado para ${values.email} com a nova senha.`,
            ""
          )
        }
        if (error?.status === 403) {
          toast("warning", error?.message, "Erro")
        } else {
          toast(
            "warning",
            `Erro ao tentar redefinir a senha. ${error?.message}.`,
            "Erro"
          )
        }
      } finally {
        setIsLoading(false)
      }
    },
  })

  return (
    <React.Fragment>
      <div
        className="account-pages my-5 pt-sm-5"
        style={{
          position: "absolute",
          left: "0",
          right: "0",
          top: "0",
          bottom: "0",
          margin: "auto",
          zIndex: "100",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("Reset Header 1")}</h5>
                        <p>{`${t("Reset Header 2")} ${
                          client.charAt(0).toUpperCase() + client.slice(1)
                        }`}</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  {/* <div className="avatar-md profile-user-wid mb-4">
                    <span className="avatar-title rounded-circle bg-light">
                      <img
                        src={logo}
                        alt=""
                        className="rounded-circle"
                        height="34"
                      />
                    </span>
                  </div> */}
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          {isLoading && (
                            <div
                              className="mt-3"
                              style={{ textAlign: "center" }}
                            >
                              <Spinner className="ms-2" color="primary" />
                            </div>
                          )}
                          {!isLoading && (
                            <button
                              className="btn btn-primary w-md "
                              type="submit"
                            >
                              {t("Redefinir Senha")}
                            </button>
                          )}
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Retorne à")}{" "}
                  <Link to="/login" className="text-secondary text-bold">
                    Login
                  </Link>{" "}
                </p>
                <p>{`SenseTek - ${t("DireitosReservados")}`}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <BgAnimado />
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(ForgetPasswordPage))
